import {USER_SAVE_CFG_ITEM} from '~/frontend/src/constants';
import {StoreState, AppDispatch, Thunk} from '~/frontend/src/store';
import saveData from '~/frontend/src/actions/data/saveData';


export type SaveCfgItemAction = {
    type : typeof USER_SAVE_CFG_ITEM;
    componentUid : string;
}

/**
 * @memberOf! Actions
 *
 * @return {}
 */
const saveCfgItem = ( componentUid : string = 'global' ) : Thunk<Promise<boolean>> => async ( dispatch : AppDispatch, getState : () => StoreState ) : Promise<boolean> => {
    dispatch( {
        type: USER_SAVE_CFG_ITEM,
        componentUid
    } );

    const user = getState().session.user;

    let retVal = false;

    if ( user ) {
        const result = await dispatch( saveData( user.itemContext, componentUid, 'userSaveCfgItem', 'CFG' ) );

        if ( result.success ) {
            retVal = true;
        }
    }

    return retVal;
}

export type SaveCfgItem = typeof saveCfgItem;

export default saveCfgItem;
